let containt='';

export function setContaint(containts){
    containt=containts
}

export function getContaint(){
    return containt;
}